// Create WebSocket connection with better error handling
const createWebSocket = () => {
  // Use production backend for deployed app, localhost for development
  // Can be overridden with REACT_APP_USE_PROD_BACKEND=true for local development
  const useProductionBackend = process.env.NODE_ENV === 'production' || 
                               process.env.REACT_APP_USE_PROD_BACKEND === 'true';
  
  const wsUrl = useProductionBackend
    ? 'wss://gamegarden.co/game' 
    : 'ws://localhost:8080/game';
  
  console.log('🔍 WebSocket Debug Info:');
  console.log('NODE_ENV:', process.env.NODE_ENV);
  console.log('REACT_APP_USE_PROD_BACKEND:', process.env.REACT_APP_USE_PROD_BACKEND);
  console.log('useProductionBackend:', useProductionBackend);
  console.log('Final WebSocket URL:', wsUrl);
  
  const ws = new WebSocket(wsUrl);
  
  ws.addEventListener('open', () => {
    console.log(`WebSocket connected successfully to ${wsUrl}`);
  });

  ws.addEventListener('error', (error) => {
    console.error('🚨 WebSocket error details:', error);
    console.error('Error type:', error.type);
    console.error('Error target:', error.target);
    console.error('Attempting to connect to:', wsUrl);
  });

  ws.addEventListener('close', (event) => {
    console.log('🔌 WebSocket closed details:');
    console.log('Close code:', event.code);
    console.log('Close reason:', event.reason);
    console.log('Was clean:', event.wasClean);
    console.log('URL was:', wsUrl);
  });

  return ws;
};

// Global WebSocket instance
let ws: WebSocket | null = null;

// Function to get current WebSocket connection
export const getWebSocket = (): WebSocket | null => {
  return ws;
};

// Function to create and set new WebSocket connection
export const initializeWebSocket = (): Promise<WebSocket> => {
  return new Promise((resolve, reject) => {
    ws = createWebSocket();
    
    ws.onopen = () => {
      console.log("WebSocket connection established");
      resolve(ws!);
    };
    
    ws.onerror = (error) => {
      console.error("WebSocket connection failed:", error);
      reject(error);
    };
  });
};

export default ws;